import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Philosophy from "@/components/site/Philosophy";
import Affirmation from "@/components/site/Affirmation";
import Services from "@/components/site/Services";
import Testimonials from "@/components/site/Testimonials";
import Workshops from "@/components/site/Workshops";
import ScanToVisit from "@/components/site/ScanToVisit";
import ContactForm from "@/components/site/ContactForm";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <main
      data-testid="landing-page"
      className="min-h-screen bg-cream text-forest font-body overflow-x-hidden"
    >
      <Navbar />
      <Hero />
      <Philosophy />
      <Affirmation />
      <Services />
      <Testimonials />
      <Workshops />
      <ScanToVisit />
      <ContactForm />
      <Footer />
    </main>
  );
}
